import styled from 'styled-components/macro';
import { TableColumn } from 'app/components/Table';
import { flex } from 'styles/shared.styles';

export const StyledTableColumn = styled(TableColumn)`
  flex: 1 1 0%;
  ${{ ...(flex.horizontal as any) }};
  ${{ ...flex.centerHorizontalV }};
`;
